import { useState } from 'react'

export const useWidgetParams = (_params?: any) => {
	const [localParams, setLocalParams] = useState<any>(null)
	const params = { ..._params, ...(localParams || {}) }
	const onChangeParams = setLocalParams

	return { params, onChangeParams }
}
